/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STGrid {
  async GetGridDefinition(viewId : string, gridId : string, viewState : st.ViewState) : Promise<st.ViewGridDef> {
    return await componentApi.call('st', 'st-grid', 'STGrid', 'GetGridDefinition', {
      viewId,
      gridId,
      viewState,
    });
  }
  async LoadData(viewId : string, gridId : string, groupGU : string, recordStart : number, viewState : st.ViewState) : Promise<st.GridData> {
    return await componentApi.call('st', 'st-grid', 'STGrid', 'LoadData', {
      viewId,
      gridId,
      groupGU,
      recordStart,
      viewState,
    });
  }
}
export default new STGrid()
